import { render, staticRenderFns } from "./BuyerRegistrationApply.vue?vue&type=template&id=152c9fbf&scoped=true"
import script from "./BuyerRegistrationApply.vue?vue&type=script&lang=js"
export * from "./BuyerRegistrationApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c9fbf",
  null
  
)

export default component.exports